import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardTitle,
    IonSpinner,
    IonText,
    IonButton,
    useIonToast,
    IonPage,
    IonContent
} from '@ionic/react';
import { AuthenticationState, useAuth } from '../components/auth/contexts/AuthContext';

export const VerifyMagicLink: React.FC = () => {
    const [error, setError] = useState<string | null>(null);
    const { verifyMagicLink, authState } = useAuth();
    const history = useHistory();
    const [present] = useIonToast();

    useEffect(() => {
        const verifyLink = async () => {
            try {
                await verifyMagicLink();
                present({
                    message: 'Successfully logged in',
                    duration: 3000,
                    position: 'bottom',
                    color: 'success'
                });
            } catch (err) {
                const message = err instanceof Error ? err.message : 'Invalid or expired magic link';
                setError(message);
                present({
                    message,
                    duration: 3000,
                    position: 'bottom',
                    color: 'danger'
                });
            }
        };

        if (authState === AuthenticationState.UNAUTHENTICATED) {
            verifyLink();
        } else if (authState === AuthenticationState.AUTHENTICATED) {
            history.replace('/');
        }
    }, [verifyMagicLink, present, authState, history]);

    if (authState === AuthenticationState.INITIALIZING) {
        return (
            <IonPage>
                <IonContent className="ion-padding">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        minHeight: '100%' 
                    }}>
                        <IonCard style={{ width: '100%', maxWidth: '400px' }}>
                            <IonCardContent className="ion-text-center">
                                <IonSpinner />
                                <p>Verifying your login...</p>
                            </IonCardContent>
                        </IonCard>
                    </div>
                </IonContent>
            </IonPage>
        );
    }

    if (error) {
        return (
            <IonPage>
                <IonContent className="ion-padding">
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        minHeight: '100%' 
                    }}>
                        <IonCard style={{ width: '100%', maxWidth: '400px' }}>
                            <IonCardHeader>
                                <IonCardTitle>Login Failed</IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent>
                                <IonText color="danger">
                                    <p>{error}</p>
                                </IonText>
                                <IonButton expand="block" routerLink="/login">
                                    Back to Login
                                </IonButton>
                            </IonCardContent>
                        </IonCard>
                    </div>
                </IonContent>
            </IonPage>
        );
    }

    return null;
}; 